import { useEffect } from "react";
import { ManualInput } from "../../../../utils/form";
import { useManualInputRows } from "../../../../utils/hooks";

const MedicineManualInput = (props) => {
  const { form, name, setSelectedTemplate } = props;
  const { setValue, watch } = form;
  const rows = useManualInputRows();

  const currentTextValue = watch(`${name}.text`);

  useEffect(() => {
    setValue(`${name}.text`, currentTextValue);
  }, [currentTextValue, setValue, name]);

  return (
    <ManualInput
      label={
        props.templateType === "order"
          ? "Solicitud de prácticas"
          : "Prescripción"
      }
      {...props}
      {...rows}
      name={`${props.name}.text`}
    />
  );
};

export default MedicineManualInput;
